import { palette, typography } from "@src/core/styles";
import styled from "styled-components";

export const StyledAuthIcon = styled.div`
  ${typography.body_large_medium};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${palette.colors.green90};
  color: ${palette.colors.green10};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all ease-in-out 0.1s;

  &:hover {
    background-color: ${palette.colors.button_hover};
  }
`;

export const AuthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
`;
